import React, { useState, useEffect } from "react";
import PanelTemplate from "../../shares/PanelTemplate";
import { useForm } from "react-hook-form";
import MuiButton from "../../shares/MuiButton";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import useFetch from "../../../context/useFetch";
import { toast } from "react-toastify";

import MuiTextField from "../../shares/MuiTextField";
import moment from "jalali-moment";
import { fixNumbers, translateState , handleEnterKey } from "../../../utils";
import TableIconModal from "../../shares/TableIconModal";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import SizeTextGrid from "../../shares/SizeTextGrid";
import AdminOrderCard from "../shares/AdminOrderCard";
import OrderCardLeftPartTemplate from "../../shares/OrderCardLeftPartTemplate";
import AddItemModal from "./AddItemModal";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import { useSetting } from "../../../context/SettingContext";
import EditRingModal from "./EditRingModal";
import { useNavigate } from "react-router-dom";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import RemoveModal from "../../shares/RemoveModal";

const EditOrder = (props) => {
  const {
    register,
    handleSubmit,
    watch,
    setError,
    control,
    formState: { errors },
    reset,
    setValue,
  } = useForm({
    defaultValues: {},
  });

  const { defaultRingSize } = useSetting();
  const navigate = useNavigate();

  const [orderCode, setOrderCode] = useState(null);
  const [orderDetail, setOrderDetail] = useState(null);

  const getOrderApi = useFetch({
    method: "post",
    url: `Order_Service/get_order_using_order_id_for_edit`,
    trigger: false,
    data: {
      unique_id: fixNumbers(orderCode),
    },
    argFunc: (res) => {
      setOrderDetail(res);

      let tmp = {};
      let tmp_active = {};

      res.total.map((item, ind) => {
        tmp[item.id] = [];
        tmp[item.id].push(item.size_one_num);
        tmp[item.id].push(item.size_two_num);
        tmp[item.id].push(item.size_three_num);
        tmp[item.id].push(item.size_four_num);
        tmp[item.id].push(item.size_five_num);
        tmp[item.id].push(item.size_six_num);

        tmp_active[item.id] = [];
        tmp_active[item.id] = item.is_active;
      });

      setItemIsActive(tmp_active);
      setInitialValues(tmp);
    },
    errMessage: (mess) => {
      toast.error("شماره سند وجود ندارد", {
        position: toast.POSITION.TOP_CENTER,
      });
    },
  });
  const show_order_details = () => {
    if (orderCode !== null) {
      getOrderApi.reFetch();
    }
  };

  const [openModal, setOpenModal] = useState(false);

  const [initialValues, setInitialValues] = useState({});
  const [itemIsActive, setItemIsActive] = useState({});

  const [nums, setNums] = useState(new Array(defaultRingSize + 1).fill(""));
  const update_nums = (ringId, ind, nValue) => {
    let beforeNums = { ...initialValues };

    beforeNums[ringId][ind] = nValue;
    setInitialValues(beforeNums);
  };

  const [selectedItem, setSelectedItem] = useState();
  const [patchData, setPatchData] = useState();
  const [childrenItemDate, setChildrenItemDate] = useState();
  const [selecteItemStatus, setSelectItemStatus] = useState();
  const [editable, setEditable] = useState(false);
  const [selectedOrderItem, setSelectedOrderItem] = useState();

  const editDetailsApi = useFetch({
    method: "patch",
    url: `OrderItem_Service/${selectedItem}/update_order_item`,
    trigger: false,
    data: { is_active: !selecteItemStatus },
    argFunc: (res) => {
      // toast.success("ویرایش مورد  با موفقیت انجام شد.", {
      //   position: toast.POSITION.TOP_CENTER,
      // });
      getOrderApi.reFetch();
    },
    errMessage: (mess) => {
      toast.error("خطایی رخ داده است", {
        position: toast.POSITION.TOP_CENTER,
      });
    },
  });
  const deleteDetailsApi = useFetch({
    method: "delete",
    url: `OrderItem_Service/${selectedOrderItem}`,
    trigger: false,
    argFunc: (res) => {
      // toast.success("ویرایش مورد  با موفقیت انجام شد.", {
      //   position: toast.POSITION.TOP_CENTER,
      // });
      getOrderApi.reFetch();
      setOpenRemoveRingModal(false);

    },
    errMessage: (mess) => {
      toast.error("خطایی رخ داده است", {
        position: toast.POSITION.TOP_CENTER,
      });
    },
  });

  const updateDetailsApi = useFetch({
    method: "patch",
    url: `OrderItem_Service/${selectedItem}/update_order_item`,
    trigger: false,
    data: patchData,

    argFunc: (res) => {
      // toast.success("ویرایش سفارش  با موفقیت انجام شد.", {
      //   position: toast.POSITION.TOP_CENTER,
      // });
      getOrderApi.reFetch();
    },
    errMessage: (mess) => {
      toast.error("خطایی رخ داده است", {
        position: toast.POSITION.TOP_CENTER,
      });
    },
  });
  const update_ring_item = (ringItemId) => {
    setSelectedItem(ringItemId);
    setPatchData({
      size_one_num:
        initialValues[ringItemId][0] !== ""
          ? parseInt(fixNumbers(initialValues[ringItemId][0]))
          : 0,
      size_two_num:
        initialValues[ringItemId][1] !== ""
          ? parseInt(fixNumbers(initialValues[ringItemId][1]))
          : 0,
      size_three_num:
        initialValues[ringItemId][2] !== ""
          ? parseInt(fixNumbers(initialValues[ringItemId][2]))
          : 0,
      size_four_num:
        initialValues[ringItemId][3] !== ""
          ? parseInt(fixNumbers(initialValues[ringItemId][3]))
          : 0,
      size_five_num:
        initialValues[ringItemId][4] !== ""
          ? parseInt(fixNumbers(initialValues[ringItemId][4]))
          : 0,
      size_six_num:
        initialValues[ringItemId][5] !== ""
          ? parseInt(fixNumbers(initialValues[ringItemId][5]))
          : 0,
      receive_at: moment(childrenItemDate).format("YYYY-MM-DD"),
      is_active: true,
    });

    // let before = { ...itemIsActive };
    // before[ringItemId] = true;
    // setItemIsActive(before);
    // setSelectItemStatus(true);
    // setCurrentOerdersDetail({
    //   results: [],
    //   detail: {},
    // });
    updateDetailsApi.reFetch();
  };

  const edit_ring_item = (ringItemId, is_acitve) => {
    setSelectedItem(ringItemId);
    setSelectItemStatus(is_acitve);
    editDetailsApi.reFetch();
  };

  const move_date_to_parent = (date) => {
    setChildrenItemDate(date);
  };

  const editable_component_data = (date, id) => {
    setEditable(date);
    let before = { ...itemIsActive };
    before[id] = !before[id];
    setItemIsActive(before);
  };

  useEffect(() => {
    if (openModal == true)
      if (orderDetail !== undefined)
        if (orderDetail.hasOwnProperty("id")) {
          getOrderApi.reFetch();
        }
  }, [openModal]);

  const [openAddItemModal, setOpenAddItemModal] = useState(false);
  const handleAddItemModal = () => {
    // setOpenAddItemModal((before) => !before);

    navigate("/create-order-customer", {
      state: { orderId: orderDetail?.id, userInfo: orderDetail?.user },
    });
  };
  const [openEditRingModal, setOpenEditRingModal] = useState(false);
  const handleEditRingModal = (order_item_id) => {
    setSelectedOrderItem(order_item_id);
    setOpenEditRingModal((before) => !before);
  };
  const [openRemoveRingModal, setOpenRemoveRingModal] = useState(false);
  const handleRemoveRingModal = (order_item_id) => {
    setSelectedOrderItem(order_item_id);
    setOpenRemoveRingModal((before) => !before);
  };

  return (
    <>
      {openAddItemModal && (
        <AddItemModal
          item={orderDetail}
          openModal={openAddItemModal}
          setOpenModal={setOpenAddItemModal}
          getOrderApi={getOrderApi}
          setOrderDetail={setOrderDetail}
        />
      )}
      {openEditRingModal && (
        <EditRingModal
          item={orderDetail}
          openModal={openEditRingModal}
          setOpenModal={setOpenEditRingModal}
          getOrderApi={getOrderApi}
          orderId={selectedOrderItem}
        />
      )}
      {openRemoveRingModal && (
        <RemoveModal
          openModal={openRemoveRingModal}
          setOpenModal={setOpenRemoveRingModal}
          onClick={() => deleteDetailsApi.reFetch()}
          text="آیا از حذف النگو موردنظر اطمینان دارید؟"
        />
      )}
      <PanelTemplate sidebarActiveLink={"quick-access-edit-order"}>
        <div className="panel-main-header">
          <span className="">ویرایش سفارش</span>
        </div>

        <div className="flex items-center border-dashed border-b pb-4">
          <div className="">
            <MuiTextField
              id="outlined-basic"
              label="شماره سند"
              variant="outlined"
              size="small"
              name="name"
              control={control}
              onChange={(e) => setOrderCode(e.target.value)}
              register={{
                required: {
                  value: true,
                  message: "شماره سند را وارد کنید.",
                },
              }}
              autoFocus
              onKeyDown={(e) => handleEnterKey(e ,show_order_details ) }
            />
          </div>

          <div className="mr-4">
            <MuiButton
              onClick={show_order_details}
              variant="contained"
              icon={<ArrowDownwardIcon />}
              color="primary"
              text=" نمایش اطلاعات سفارش "
              disabled={getOrderApi.loading}
            />
          </div>
        </div>
        {orderDetail !== null ? (
          <>
            <div className="grid grid-cols-5 py-4 border-dashed border-b">
              <div className=" text-right">
                <span className="font-bold text-myblue-100">
                  اطلاعات سفارش:
                </span>
              </div>
              <div className=" text-center">
                <span className="">
                  مشتری:{" "}
                  <span className="text-myblue-100">{orderDetail?.name}</span>
                </span>
              </div>
              <div className=" text-center">
                <span>
                  سند:{" "}
                  <span className="text-myblue-100">
                    {orderDetail?.unique_id}
                  </span>
                </span>
              </div>
              <div className=" text-center">
                <span>
                  تاریخ ثبت سفارش:{" "}
                  <span className="text-myblue-100">
                    {moment(orderDetail?.created_at, "YYYY/MM/DD")
                      .locale("fa")
                      .format("YYYY/MM/DD")}
                  </span>
                </span>
              </div>
              <div className=" text-center">
                <span>
                  وضعیت سفارش:{" "}
                  <span className="text-myblue-100">
                    {translateState(orderDetail?.state)}
                  </span>
                </span>
              </div>
            </div>
            <div className="flex justify-between mt-8">
              <span className="font-bold text-myblue-100">جزییات سفارش:</span>
              <MuiButton
                onClick={handleAddItemModal}
                variant="contained"
                color="primary"
                text="افزدون ایتم"
                size="small"
                icon={<AddCircleOutlineIcon />}
              />
            </div>
            <div className="flex justify-between items-center">
              <div className="basis-10/12">
                <SizeTextGrid haveExtraCol have5Col />
              </div>
              <div className="basis-2/12"></div>
            </div>
            <div>
              {orderDetail?.total.map((item, index) => {
                return [
                  <>
                    <div className="flex justify-between items-center">
                      <div className="basis-10/12">
                        <AdminOrderCard
                          update_ring_item={update_ring_item}
                          edit_ring_item={edit_ring_item}
                          showAcceptBtn
                          DontshowEditIconForAdmin
                          item={item}
                          move_date_to_parent={move_date_to_parent}
                          editable_component={editable_component_data}
                          adminNeedDifference
                          DontShowDatePicker
                        >
                          <OrderCardLeftPartTemplate
                            nums={nums}
                            update_nums={update_nums}
                            dynamicMap={true}
                            data_item={item}
                            // order_item_is_active={item.is_active}
                            ringId={item.id}
                            // adminCantEdit={itemIsActive[item.id] ? true : false}
                            // adminDidntNeedCustomerRequestNum
                            DontShowAcceptItem
                            adminNeedColor
                            customerCanEdit
                          />
                        </AdminOrderCard>
                      </div>
                      <div className="basis-2/12 mt-2 flex justify-around">
                        <MuiButton
                          onClick={() => handleEditRingModal(item.id)}
                          variant="outlined"
                          color="primary"
                          text="تغییر"
                          size="small"
                          icon={<ModeEditIcon />}
                        />
                        <MuiButton
                          onClick={() => handleRemoveRingModal(item.id)}
                          variant="outlined"
                          color="secondary"
                          text="حذف"
                          size="small"
                          icon={<DeleteOutlineIcon />}
                        />
                      </div>
                    </div>
                  </>,
                ];
              })}
            </div>
          </>
        ) : (
          ""
        )}
      </PanelTemplate>
    </>
  );
};

export default EditOrder;
